<div class="mt-4 mb-4" *ngIf="invoice">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice']">Factures</button></li>
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice']" [queryParams]="{supplier: invoice.supplier.name}">{{ invoice.supplier.name }}</button></li>
    <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice', invoice.id]" >{{ invoice.supplierInvoiceNumber }}</button></li>
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Needa</button></li>
  </ol>
</div>

<pre class="p-3 bg-white">{{ needaFile }}</pre>